<template>
    <Modal :value="isShow" :closable='false' :mask-closable=false :width="500" class="win-box" :styles="{top: '230px'}">
        <div class="role-box">
            <div class="win-title">
                <span>请选择您的登录身份</span>
            </div>
            <ul>
                <li v-for="(item,index) in curUserRoleList" :key="item.userid">
                    <button class="btn role-item-selected" v-if="item.isSelected === '1'">
                        <i class="selected"></i>
                        {{convertUserType(item.user_type)}}
                    </button>
                    <button class="btn role-item" v-on:click="selectUserRole(index)" v-else>
                        {{convertUserType(item.user_type)}}
                    </button>
                </li>
            </ul>
            <div class="sure-box">
                <button class="btn sure" v-on:click="sureBtn()">确认</button>
            </div>
        </div>
        <div slot="footer">
        </div>
    </Modal>
</template>

<script>
    export default {
        name: "select-user-type",
        props: ['isShow', 'userRoleList'],
        data() {
            return {
                curUserRoleList: [],
                userRole: ''
            }
        },
        watch: {
            'isShow': 'initButtonStyle'
        },
        methods: {
            /**
             * 初始化按钮的选择状态
             */
            initButtonStyle() {
                if (this.isShow) {
                    this.curUserRoleList = [...this.userRoleList];
                    for (let i = 0; i < this.curUserRoleList.length; i++) {
                        this.curUserRoleList[i].isSelected = '-1';
                    }
                }
            },
            /**
             * 用户类型数字转换为中文字符串
             */
            convertUserType(userType) {
                switch (userType) {
                    case 0:
                        return '注册用户';
                        break;
                    case 1:
                        return '教师';
                        break;
                    case 2:
                        return '学生';
                        break;
                    case 3:
                        return '家长';
                        break;
                    case 4:
                        return '代理商';
                        break;
                    case 5:
                        return '运营';
                        break;
                }
            },
            /**
             * 点击选择角色
             */
            selectUserRole(index) {
                let _this = this;
                _this.initButtonStyle();
                _this.userRoleList[index].isSelected = '1';
                _this.userRole = _this.curUserRoleList[index].user_type
            },
            /**
             * 确认选择按钮点击事件
             */
            sureBtn() {
                if (this.userRole === '') {
                    this.$Message.error('请选择您的登录身份！');
                    return;
                }
                this.$emit('updateUserType', this.userRole);
            }
        }
    }
</script>

<style lang="scss" scoped>

    /*身份选择*/
    .role-box {
        margin: auto;
        position: relative;
        width: 380px;
        height: 325px
    }

    .role-box .win-title {
        height: 70px;
        top: 0;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .role-box .win-title span {
        font-size: 18px;
        font-family: "Microsoft YaHei";
        color: rgb(85, 85, 85);
        text-align: center;
        position: absolute;
        float: left;
        left: 28%;
    }

    .role-box ul {
        margin-bottom: 25px;
    }

    .role-box ul > li {
        margin-top: 10px;
        margin-bottom: 20px;
        height: 40px;
    }

    .role-box .btn {
        border-style: solid;
        border-width: 1px;
        -webkit-border-radius: 5px;
        width: 222px;
        height: 38px;
        left: 21%;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        cursor: pointer;
    }

    .role-box .btn:focus {
        outline: none;
    }

    .role-box .role-item {
        border-color: rgb(204, 204, 204);
        background-color: rgb(255, 255, 255);
        position: absolute;
    }

    .role-box .role-item-selected {
        border-color: rgb(74, 159, 255);
        color: rgb(74, 159, 255);
        background-color: rgb(255, 255, 255);
        position: absolute;
    }

    .role-box .selected {
        background: url(../assets/images/login/selected.png) no-repeat;
        width: 14px;
        height: 10px;
        position: absolute;
        margin-left: -50px;
        margin-top: 8px;
    }

    .role-box .sure-box {
        position: absolute;
        height: 40px;
        bottom: -30px;
        width: 380px;
    }

    .role-box .sure {
        background-color: rgb(74, 159, 255);
        position: absolute;
        color: rgb(255, 255, 255);
    }
</style>
<style>
    .win-box .ivu-modal-footer {
        border-top: 0px solid #e9eaec !important;
        padding: 12px 18px 12px 18px;
        text-align: right;
    }

    .win-box .ivu-modal-content {
        height: 400px;
    }
</style>
